import { RouteProps } from 'react-router-dom';
import { NotFoundPage } from 'Components/pages';

interface PrivateRouteProps extends Omit<RouteProps, 'element'> {
    element: JSX.Element;
    userRole: string | null;
    allowedRoles: string[];
}

const PrivateRoute = ({ element, userRole, allowedRoles }: PrivateRouteProps) => {
    const isAuthorized = userRole && allowedRoles.includes(userRole);

    return isAuthorized ? element : <NotFoundPage />;
};
export default PrivateRoute;
